import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vShow as _vShow, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "right_cont" }
const _hoisted_2 = { class: "t6_title_h1" }
const _hoisted_3 = { class: "t6_search" }
const _hoisted_4 = { class: "tab_content" }
const _hoisted_5 = { class: "tab_cont" }
const _hoisted_6 = { class: "sq_list sq_list2" }
const _hoisted_7 = { class: "tab_content" }
const _hoisted_8 = {
  key: 0,
  class: "tab_cont"
}
const _hoisted_9 = { class: "sq_list" }
const _hoisted_10 = { class: "li_tit" }
const _hoisted_11 = { class: "li_ms" }
const _hoisted_12 = { class: "li_btn" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "sign" }
const _hoisted_18 = { class: "li_tit" }
const _hoisted_19 = { class: "li_ms" }
const _hoisted_20 = { class: "pagination" }

import {getModelInfoList, queryListByTag} from '@/config/request'
import { reactive, ref, toRefs, watchEffect } from 'vue'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    tagName: String,
    keyWord:String,
    listName:String
},
  setup(__props) {

const router = useRouter()
const props = __props
const { tagName,keyWord,listName } = toRefs(props) as any
let data = reactive({
    fwqd: false,    //  false表示不是服务清单
})

const toPath = (item:any) => {
  router.push({
    path:'./one-thing/selection-situation',
    query: {
      modelCode:item.modelCode,
      modelName:item.modelName,
      parentid:item.parentid,
      theme:item.theme,
      hangyeType_dictText:item.hangyeType_dictText
    }
  })
}

const toWorkGuide = (item:any) => {
    router.push({
        path: '/do-things-online/work-guide',
        query: {
            serviceCode: item.serviceCode,
            serviceName: item.serviceName,
            tagName: item.tagName,
        },
    })
}

const toDeclaration = (item:any) => {
    let status = 0
    //  isKfSelf 自建事项 1是
    //  isWeburlEffect 外链生效 1不生效
    if(item.isKfSelf != '1' && item.isWeburlEffect != '1'){
        status = 1
        location.href = item.webUrl
    }
    let query = {
        serviceCode: item.serviceCode,
        serviceName: item.serviceName,
        tagName: item.tagName,
    } as any
    //  判断是否是秒批事项申报，因为有的事项既是普通事项又是秒批事项，通过申报位置判断后续申报逻辑
    if(tagName.value === '智能秒办'){
        query.ismp = '1'    //  1代表是秒批申报  其他值代表不是
    }
    if(status === 0){
        //  先跳转通知事项 再进入申报
        router.push({
            path: '/do-things-online/notic',
            query: query,
        })
    }
}


const toReservation = (item:any) => {
  let query = {
    serviceCode: item.serviceCode,
    serviceName: item.serviceName,
    tagName: item.tagName,
  } as any

    //  先跳转通知事项 再进入申报
  router.push({
    path: '/do-things-online/reservation',
    query: query,
  })
}
let keyWords = ref('')
if(keyWord.value){
    keyWords.value = keyWord.value
}
let dataList = ref([]) as any
const paginate = reactive({
    pageNo: 1,
    pageSize: 5,
    pageSizes: [5,10,20],
    total: 0,
})
const handleCurrentChange = (index:any) => {
    paginate.pageNo = index
    init()
}
const handleSizeChange = (index:any) => {
    paginate.pageSize = index
    init()
}
const openFile = (name:string) => {
    if(name) window.open(`/staticFile/${name}`)
}

const init = async() => {
    data.fwqd = false
    if(!tagName.value){
        return false
    }else if(tagName.value === '服务清单'){     //  这个目前是死页面
        data.fwqd = true
        return false
    }
  console.log(listName.value,tagName.value,"====================")
    if(listName.value === 'yyyz'){
      let param = {
        listName: listName.value,
        modelName: keyWords.value,
        pageSize: paginate.pageSize,
        pageNo: paginate.pageNo,
      }
      const res = await getModelInfoList(param) as any
      dataList.value = res.result?.records || []
      paginate.total = res.result?.total || 0
    } else {
      let param = {
        tagName: tagName.value,
        serviceName: keyWords.value,
        pageSize: paginate.pageSize,
        pageNo: paginate.pageNo,
      }
      const res = await queryListByTag(param) as any
      dataList.value = res.result?.records || []
      paginate.total = res.result?.total || 0
    }

}
watchEffect(()=>{
    init()
})
init()

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_unref(tagName)) + " ", 1),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "ipt_txt",
          placeholder: "请输入关键字查询",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(keyWords) ? (keyWords).value = $event : keyWords = $event))
        }, null, 512), [
          [_vModelText, _unref(keyWords)]
        ]),
        _createElementVNode("button", {
          class: "ss_btn",
          onClick: init
        }, "查 询")
      ], 512), [
        [_vShow, !_unref(data).fwqd]
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openFile('ZMQOneThingAtATimeToDoList.pdf')))
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("div", { class: "li_tit" }, "自贸试验区开封片区“高效办成一件事”事项清单", -1)
          ]))]),
          _createElementVNode("li", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (openFile('ZMQBasicCatalogOfGovernmentServices.pdf')))
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("div", { class: "li_tit" }, "中国（河南）自由贸易试验区开封片区政务服务基本目录", -1)
          ]))])
        ])
      ])
    ], 512), [
      [_vShow, _unref(data).fwqd]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      (_unref(dataList).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("ul", _hoisted_9, [
              (_unref(listName)!='yyyz')
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(dataList), (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.id
                    }, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(item.serviceName), 1),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", null, "事项编码：" + _toDisplayString(item.serviceCode), 1),
                        _createElementVNode("span", null, "办理机构：" + _toDisplayString(item.deptName), 1),
                        _createElementVNode("span", null, "事项类型：" + _toDisplayString(item.serviceType_dictText), 1)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("a", {
                          class: "btn1 green_border_btn",
                          onClick: ($event: any) => (toWorkGuide(item))
                        }, "办事指南", 8, _hoisted_13),
                        _createElementVNode("a", {
                          class: "btn1 blue_border_btn",
                          onClick: ($event: any) => (toDeclaration(item))
                        }, "在线申报", 8, _hoisted_14),
                        _createElementVNode("a", {
                          class: "btn1 green_border_btn",
                          onClick: ($event: any) => (toReservation(item))
                        }, "在线预约", 8, _hoisted_15)
                      ])
                    ]))
                  }), 128))
                : _createCommentVNode("", true),
              (_unref(listName) =='yyyz')
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(dataList), (item, i) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.unid,
                      onClick: ($event: any) => (toPath(item))
                    }, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", null, _toDisplayString(item.userType), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(item.modelName), 1),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("span", null, "主办单位：" + _toDisplayString(item.leadDept), 1),
                        _createElementVNode("span", null, "事项类型：" + _toDisplayString(item.onetingType), 1),
                        _createElementVNode("span", null, "联办单位：" + _toDisplayString(item.jointDapt), 1)
                      ])
                    ], 8, _hoisted_16))
                  }), 128))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_el_pagination, {
                background: "",
                onCurrentChange: handleCurrentChange,
                onSizeChange: handleSizeChange,
                layout: "sizes, prev, pager, next, ->, total",
                "page-size": paginate.pageSize,
                "page-sizes": paginate.pageSizes,
                total: paginate.total
              }, null, 8, ["page-size", "page-sizes", "total"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(dataList).length === 0)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            "image-size": "100",
            description: "暂无数据"
          }))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !_unref(data).fwqd]
    ])
  ]))
}
}

})